<template>
  <div>
    <!-- <svg-icon :class="isFullscreen?'exit-fullscreen':'fullscreen'" @click="click" /> -->

    <div :class="isFullscreen?'exit-fullscreen fullscreenimg':'fullscreen fullscreenimg'" @click="click" ></div>

  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'Screenfull',
  data() {
    return {
      isFullscreen: false
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    click() {
      // if (!screenfull.enabled) {
      //   this.$message({
      //     message: 'you browser can not work',
      //     type: 'warning'
      //   })
      //   return false
      // }
      screenfull.toggle()
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen
    },
    init() {
      if (screenfull.enabled) {
        screenfull.on('change', this.change)
      }
    },
    destroy() {
      if (screenfull.enabled) {
        screenfull.off('change', this.change)
      }
    }
  }
}
</script>

<style scoped>
.screenfull-svg {
  display: inline-block;
  cursor: pointer;
  fill: #5a5e66;;
  width: 20px;
  height: 20px;
  vertical-align: 10px;
}

.exit-fullscreen{
  background: url(../../assets/exit-fullscreen.png);
}
.fullscreen{
  background: url(../../assets/fullscreen.png);
 
}
.fullscreenimg{
  width: 20px;
  height: 20px;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// index.vue?79580642